import { render, staticRenderFns } from "./Shangpitu.vue?vue&type=template&id=7f2518de&"
import script from "./Shangpitu.vue?vue&type=script&lang=js&"
export * from "./Shangpitu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports